import { OTPInput as InputOTP, SlotProps } from "input-otp";
import { cn } from "../util/tailwind-ext";
import { IonText } from "@ionic/react";

export default function OTPInput(props: {
  value: string;
  onChange: (newValue: string) => void;
}) {
  return (
    <InputOTP
      autoFocus
      maxLength={6}
      containerClassName="group flex items-center has-[:disabled]:opacity-30"
      value={props.value}
      onChange={props.onChange}
      pushPasswordManagerStrategy="none"
      render={({ slots }) => (
        <>
          <div className="flex">
            {slots.slice(0, 3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
          <FakeDash />
          <div className="flex">
            {slots.slice(3).map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
        </>
      )}
    />
  );
}

function Slot(props: SlotProps) {
  return (
    <div
      className={cn(
        "relative h-14 w-10 text-[2rem]",
        "flex items-center justify-center",
        "transition-all duration-300",
        "border-border border-y border-r first:rounded-l-md first:border-l last:rounded-r-md",
        "group-hover:border-accent-foreground/20 group-focus-within:border-accent-foreground/20",
        "outline-accent-foreground/20 outline outline-0",
        { "outline-4 outline-black": props.isActive },
      )}
    >
      {props.char !== null && (
        <div>
          <IonText>{props.char}</IonText>
        </div>
      )}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

function FakeCaret() {
  return (
    <div className="pointer-events-none absolute inset-0 flex animate-caret-blink items-center justify-center">
      <div className="h-8 w-px bg-black" />
    </div>
  );
}

function FakeDash() {
  return (
    <div className="flex w-10 items-center justify-center">
      <div className="bg-border h-1 w-3 rounded-full bg-gray-300" />
    </div>
  );
}
